import React from "react";

const Panel = props => {
  return (
    <div className={`panel panel-${props.panelType} ${props.panelClass}`}>
      <div className="panel-heading" style={props.panelHeaderStyle}>
        <h2>
          <span className={`${props.panelIcon} ${props.panelHeaderClass}`} />{" "}
          {props.panelHeader}
        </h2>
      </div>
      <div
        className={`panel-body ${props.panelBodyClass}`}
        style={props.panelBodyStyle}
      >
        {props.panelBody}
      </div>
    </div>
  );
};
export default Panel;
